var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3531 3.51094C11.4469 3.60469 11.5 3.73125 11.5 3.86406V13.5C11.5 13.7766 11.2766 14 11 14H1C0.723437 14 0.5 13.7766 0.5 13.5V0.5C0.5 0.223437 0.723437 0 1 0H7.63594C7.76875 0 7.89688 0.053125 7.99063 0.146875L11.3531 3.51094ZM10.3469 4.09375L7.40625 1.15313V4.09375H10.3469Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.50c0c2d6ddd9f723f0b85d81aa156f31.svg";
export { ForwardRef as ReactComponent };